import React from "react";
import { useSelector } from "react-redux";
import { xhrFileGetReportSignedFile } from "../utilities/xhr-file";
import toastUtil from "../utilities/toast-util";

function ReportViewer({ reportId, outerToken }) {
	
	
	const [tokenApi, setTokenApi] = React.useState(outerToken);
	const token = useSelector((state) => state.session.token);
	const currentLanguage = useSelector((state) => state.session?.userPreferences?.language);
	const [currDoc, setCurrDoc] = React.useState(0);
	const [iframeLoading, setiframeLoading] = React.useState(true);

	React.useEffect(() => {
		if (token?.length > 0) {
			setTokenApi(token);
		} else {
		}
	}, [token]);

	React.useEffect(() => {
		let mountedRef = true;
		if (reportId > 0 && tokenApi?.length > 0) {
			setiframeLoading(true);
			
		const effectPromise = async () => {
				var imageUrl = await xhrFileGetReportSignedFile(tokenApi, reportId);
				//toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setCurrDoc(imageUrl);
				setiframeLoading(false);
			}
			effectPromise();
		}
		else{
			setCurrDoc(null);
		}
	}, [reportId, tokenApi]);

	return (
		<div className="d-flex flex-row  justify-content-center" style={{width: "100%",height: '100%'}}>
			<form className="w-100  light-background border-radius-2">
				{currDoc ? (
					<>
						<div
							className="bg-white w-100 screenshot-container bg-white d-flex align-items-center justify-content-center"
							style={{ position: "relative",height: '100%' }}
						>
							{Boolean(iframeLoading) && <div className="iframe-loading" />}
							<object
								type="application/pdf"
								style={{
									width: "100%",
									height: "100%"
								}} 
								data={currDoc}
							>
								<a
									href={currDoc}
									target="_blank"
									rel="noopener noreferrer"
									download={`report_${reportId}.pdf`}
									style={{
										width: "100%",
										height: "100%",
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<i
										className="zmdi zmdi-download"
										style={{
											fontSize: "xx-large",
											color: "#e78e4b",
										}}
									>
									</i>
									{"Download"}
									{"PDF"}
								</a>
							</object>
							
						</div>
					</>
				) : (
					<div className="bg-white w-100 screenshot-container bg-white p-3 border-radius-2 my-2 d-flex align-items-center justify-content-center">
						No Report to Display
					</div>
				)}
			</form>
		</div>
	);
}

export default ReportViewer;
